import { useMemo } from 'react';

import { useLazyGetContactsQuery } from '../../../../../services/contactsV2';

export const argsForColumn = ({ customFieldId, listId, value, globalFilters }) => ({
  listId,
  contextualizedToSharedListId: listId,
  filters: {
    customFields: [{ id: customFieldId, ...(value ? { value } : {}) }],
    ...globalFilters,
  },
  board: true,
});

export const useKanbanColumns = ({ customField, listId, queryParams }) => {
  const columns = useMemo(() => {
    if (!customField) return [];

    const columnOptions = customField.params?.options || [];
    const columnDefinitions = columnOptions.map((option) => ({
      id: `column:${option.id}`,
      title: option.label,
      status: option.id,
      meta: {
        customField,
        argsForColumn: argsForColumn({
          customFieldId: customField.id,
          listId,
          value: option.id,
          globalFilters: queryParams.filters,
        }),
        query: useLazyGetContactsQuery,
      },
    }));

    columnDefinitions.unshift({
      id: 'column:unassigned',
      title: 'Unassigned',
      status: null,
      meta: {
        customField,
        argsForColumn: argsForColumn({
          customFieldId: customField.id,
          listId,
          value: null,
          globalFilters: queryParams.filters,
        }),
        query: useLazyGetContactsQuery,
      },
    });

    return columnDefinitions;
  }, [customField, listId, queryParams.filters]);

  return { columns };
};
